import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const StaffModal = ({ member, onClose }) => {
  const { name, title, modalTitle, staffSubhead, imageUrl, imageAlt, bioContent } = member;
  const displayTitle = modalTitle || title;
  const closeButtonRef = useRef(null);

  useEffect(() => {
    closeButtonRef.current?.focus();

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    <div
      className="leadership-cards-modal"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="leadership-modal-name"
    >
      {/* eslint-enable */}
      <div className="modal-content">
        <button
          ref={closeButtonRef}
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <div id="modal-bio-content">
          {imageUrl && (
            <div className="modal-image">
              <img src={imageUrl} alt={imageAlt || name || ''} />
            </div>
          )}
          <div className="modal-info">
            <div id="leadership-modal-name" className="staff-name">{name}</div>
            <div className="staff-title">{displayTitle}</div>
            {staffSubhead && <div className="staff-subhead">{staffSubhead}</div>}
            {bioContent && (
              <div
                className="staff-details"
                /* eslint-disable-next-line react/no-danger */
                dangerouslySetInnerHTML={{ __html: bioContent }}
              />
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

StaffModal.propTypes = {
  member: PropTypes.shape({
    bioContent: PropTypes.string,
    imageAlt: PropTypes.string,
    imageUrl: PropTypes.string,
    modalTitle: PropTypes.string,
    name: PropTypes.string,
    staffSubhead: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default StaffModal;
